export default __webpack_public_path__ + "static/media/231.f616f24d.jpg";